import { render } from "./Contact.vue?vue&type=template&id=f4d7246e&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=f4d7246e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4d7246e"

export default script